import { Button } from "antd";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const QuizDetailsFooter = ({ form }: any) => {
  const { screen }: any = useWindowSize();
  const { setIsCreateMode, setIsDrawerOpen, setIsCourseLoading, editableQuiz } =
    useQuizContext();
  return (
    <div
      className={"footer-class"}
      style={{
        width: "100%",
        justifyContent: "space-between",
        marginTop: 16,
        paddingLeft: !["xxl", "xl", "lg"].includes(screen) ? 16 : 124,
      }}
    >
      <Button
        onClick={() => {
          setIsCreateMode(false);
        }}
        disabled={false}
      >
        Back
      </Button>
      {editableQuiz.id ? (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            form
              .validateFields()
              .then(() => {
                setIsDrawerOpen(true);
                setIsCourseLoading(true);
              })
              .catch((error: any) => {
                console.log(error);
              });
          }}
          disabled={false}
        >
          Next
        </Button>
      ) : (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            form
              .validateFields()
              .then(() => {
                setIsDrawerOpen(true);
                setIsCourseLoading(true);
              })
              .catch((error: any) => {
                console.log(error);
              });
          }}
        >
          Next
        </Button>
      )}
    </div>
  );
};

export default QuizDetailsFooter;
